// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-tests-MdmCardDemoPage-MdmCardFormDemo-module__box--Jdx3w {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.src-pages-tests-MdmCardDemoPage-MdmCardFormDemo-module__tools--vZ1Ol {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 0 8px;
  margin-top: 5px;
  align-items: center;
}
.src-pages-tests-MdmCardDemoPage-MdmCardFormDemo-module__submitBox--HWsyB {
  flex: 1;
  text-align: right;
}
.src-pages-tests-MdmCardDemoPage-MdmCardFormDemo-module__content--u8Aaa {
  flex: 1;
  overflow: auto;
}
/*# sourceMappingURL=MdmCardFormDemo.module.css.map */`, "",{"version":3,"sources":["webpack://./MdmCardFormDemo.module.less","webpack://./src/pages/tests/MdmCardDemoPage/MdmCardFormDemo.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ACCF;ADCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;ACCF;ADCA;EACE,OAAA;EACA,iBAAA;ACCF;ADCA;EACE,OAAA;EACA,cAAA;ACCF;AACA,qDAAqD","sourcesContent":[".box {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.tools {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  padding: 0 8px;\n  margin-top: 5px;\n  align-items: center;\n}\n.submitBox {\n  flex: 1;\n  text-align: right;\n}\n.content {\n  flex: 1;\n  overflow: auto;\n}\n",".box {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.tools {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  padding: 0 8px;\n  margin-top: 5px;\n  align-items: center;\n}\n.submitBox {\n  flex: 1;\n  text-align: right;\n}\n.content {\n  flex: 1;\n  overflow: auto;\n}\n/*# sourceMappingURL=MdmCardFormDemo.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-pages-tests-MdmCardDemoPage-MdmCardFormDemo-module__box--Jdx3w`;
export var tools = `src-pages-tests-MdmCardDemoPage-MdmCardFormDemo-module__tools--vZ1Ol`;
export var submitBox = `src-pages-tests-MdmCardDemoPage-MdmCardFormDemo-module__submitBox--HWsyB`;
export var content = `src-pages-tests-MdmCardDemoPage-MdmCardFormDemo-module__content--u8Aaa`;
export default ___CSS_LOADER_EXPORT___;
